import {
  SUBSCRIPTION_BUSINESS,
  SUBSCRIPTION_BUSINESS_ANNUAL,
  SUBSCRIPTION_CREATOR,
  SUBSCRIPTION_CREATOR_ANNUAL,
} from '../config';

export const getTierSummaryConfig = (tier?: number) => {
  switch (tier) {
    case SUBSCRIPTION_CREATOR:
      return creatorMonthlyTierSummary;
    case SUBSCRIPTION_CREATOR_ANNUAL:
      return creatorAnnualTierSummary;
    case SUBSCRIPTION_BUSINESS:
      return buisnessMonthlyTierSummary;
    case SUBSCRIPTION_BUSINESS_ANNUAL:
      return buisnessAnnualTierSummary;
  }
};

const creatorMonthlyTierSummary = {
  title: 'Creator',
  features: [
    'AI video microlesson builder',
    'AI assistant builder',
    '1,000,000 AI credits',
    '5 GB Storage',
    'LTI/SCORM export',
    '1 creator license',
    'supports up to 19 learners with tapybl LMS',
  ],
  price: '€29',
  annual: false,
};

const buisnessMonthlyTierSummary = {
  title: 'Business',
  features: [
    'AI video microlesson builder',
    'AI assistant builder',
    '2,000,000 AI credits',
    '50 GB Storage',
    'LTI/SCORM export',
    '1 creator license',
    'supports up to 99 learners with tapybl LMS',
  ],
  price: '€99',
  annual: false,
};

const creatorAnnualTierSummary = {
  title: 'Creator',
  features: [
    'AI video microlesson builder',
    'AI assistant builder',
    '12,000,000 AI credits',
    '5 GB Storage',
    'LTI/SCORM export',
    '1 creator license',
    'supports up to 19 learners with tapybl LMS',
  ],
  price: '€340',
  annual: true,
};

const buisnessAnnualTierSummary = {
  title: 'Business',
  features: [
    'AI video microlesson builder',
    'AI assistant builder',
    '24,000,000 AI credits',
    '50 GB Storage',
    'LTI/SCORM export',
    '1 creator license',
    'supports up to 99 learners with tapybl LMS',
  ],
  price: '€1,100',
  annual: false,
};
